import React, { useState } from "react";
import { FileSignature } from "lucide-react";
import AgreementRequestsList from "../../components/AgreementRequestsList";
import PageHeader from "../../components/PageHeader";
import Tabs from "../../components/Tabs";

const TABS = [{ key: "interior_execution_agreements", label: "Interior Execution Agreements" }];

/**
 * Zumale-admin "Requests" hub. Currently one tab — Interior Execution Agreements — which lists
 * agreements pending the BuildVizer signature (with each other party's status) and completed ones.
 * More request types can be added as tabs later.
 */
const Requests = () => {
  const [tab, setTab] = useState(TABS[0].key);

  return (
    <div className="p-6 lg:p-8 flex flex-col gap-6 min-h-[calc(100vh-4rem)]">
      <PageHeader
        icon={FileSignature}
        title="Requests"
        subtitle="Agreements and approvals awaiting BuildVizer action"
      />

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
        <Tabs tabs={TABS} active={tab} onChange={setTab} />
        <div className="p-4 lg:p-5">
          {tab === "interior_execution_agreements" && <AgreementRequestsList />}
        </div>
      </div>
    </div>
  );
};

export default Requests;
